import {Box, BoxProps, Container, Heading, HStack} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import ImageUI from 'ui/ImageUI';

interface Props extends BoxProps {
  heading?: string;
  icon: string;
}

export const IconBlock: FC<Props> = ({icon, heading, children, ...boxProps}) => {
  return (
    <Container variant="white-block" {...boxProps}>
      <HStack alignItems="flex-start" spacing="0">
        <ImageUI mr="15px" w="50px" borderRadius="10px" src={icon} alt="icon" />
        <Box w="full">
          {heading && (
            <Heading as="h5" fontSize="16px" fontWeight="600" color={colors.lightBlack} mb="12px">
              {heading}
            </Heading>
          )}
          {children}
        </Box>
      </HStack>
    </Container>
  );
};
